import { useClientRest } from "@shared/hooks";
import { toSnake, transformQueryParamsWithoutLocale } from "@shared/utils";
import { Ninja_Sub_Districts } from "@sisnaker-react-core/karirhub-model-type";
import { useQuery } from "@tanstack/react-query";

export function useSubDistricts({
  keyword,
  cityIds,
  page = 1,
  limit = 10,
  enabled = true,
}: {
  keyword: string;
  cityIds?: string[];
  page?: number;
  limit?: number;
  enabled?: boolean;
}) {
  const { request } = useClientRest();

  const query = useQuery<{ data: Ninja_Sub_Districts[] }>({
    queryKey: ["common-sub-districts-", keyword, (cityIds || [])?.join(","), limit, page],
    queryFn: () =>
      request({
        url: transformQueryParamsWithoutLocale("/karirhub/onboarding/v2/sub-districts", toSnake({
          keyword,
          cityIds,
          limit,
          page,
        })),
        method: "GET",
        options: {
          cache: "no-store",
        },
      }),
    enabled: enabled,
  });

  const refetch = () => {
    query.refetch();
  };

  return {
    isLoading: query.isLoading,
    subDistricts: query.data?.data || [],
    query,
    refetch,
  };
}
